module.exports = __webpack_public_path__ + "img/recordfu-btn.6f679f39.png";